<div class="text-center">
  <ci-phosphor-icon name="warning" weight="fill" size="lg" variant="warning" />
</div>
<div class="text-center mt-3 mb-4">
  <app-h4>Warning: BACS Submission Date Has Passed</app-h4>
</div>
<div class="text-center">
  <app-content>
    <app-p>
      You are about to revert the payment status from <app-body bold>'Paid by employer'</app-body>
      but the BACS submission date has already passed.
    </app-p>

    <app-body bold>Important Considerations:</app-body>

    <app-p> If you change the status to <app-body bold>'Paid by bureau'</app-body>, you will need to: </app-p>

    <app-content class="bullet-list">
      <ul>
        <li>Cancel the current payment</li>
        <li>Create a new payment with the correct pay date</li>
        <li>Ensure compliance with payroll processing timelines</li>
      </ul>
    </app-content>

    <app-body-ml bold>Are you sure you want to proceed with this change?</app-body-ml>
  </app-content>
</div>
